import React, { useState, useEffect } from 'react';
import axios from 'axios';
// require('dotenv').config();
const BlogForm = () => {
  const [formData, setFormData] = useState({
    title: '',
    username: '',
    date: '',
    content: '',
    image: null,
  });

  const [blogs, setBlogs] = useState([]);
  const [editId, setEditId] = useState(null);
  const [message, setMessage] = useState('');

  // 🟢 Fetch all blogs on load
  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/blogs`);
    setBlogs(res.data);
  };

  // 🟢 Form field change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // 🟢 File select
  const handleFileChange = (e) => {
    setFormData(prev => ({ ...prev, image: e.target.files[0] }));
  };

  // 🟢 Submit form (create or update)
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('title', formData.title);
    data.append('username', formData.username);
    data.append('date', formData.date);
    data.append('content', formData.content);
    if (formData.image) data.append('image', formData.image);

    try {
      if (editId) {
        await axios.put(`${process.env.REACT_APP_API_URL}/api/blogs/${editId}`, data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        setMessage('✅ Blog updated!');
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/api/blogs`, data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        setMessage('✅ Blog created!');
      }

      fetchBlogs();
      resetForm();
    } catch (err) {
      console.error(err);
      setMessage('❌ Failed to submit blog.');
    }
  };

  // 🟢 Reset form to default
  const resetForm = () => {
    setFormData({
      title: '',
      username: '',
      date: '',
      content: '',
      image: null,
    });
    setEditId(null);
  };

  // 🟢 Start editing
  const handleEdit = (blog) => {
    setEditId(blog.id);
    setFormData({
      title: blog.title,
      username: blog.username,
      date: blog.date.slice(0, 10),
      content: blog.content,
      image: null,
    });
    window.scrollTo(0, 0);
  };

  // 🟢 Delete blog
  const handleDelete = async (id) => {
    if (window.confirm('Delete this blog?')) {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/blogs/${id}`);
      fetchBlogs();
    }
  };

  return (
    <div className="max-w-3xl font-[Poppins]">
      <div className="rounded-xl">

        <h2 className="text-3xl font-bold mb-4">
          {editId ? '📝 Edit Blog' : '🦜 Write a Blog Post'}
        </h2>
        {message && <div className="mb-4 text-center text-pink-500 font-medium">{message}</div>}

        <form onSubmit={handleSubmit} className="space-y-4 mt-10" encType="multipart/form-data">
        <label htmlFor="Blog Title" className='text-lg font-[500] '>Blog Title</label>
          <input
            type="text"
            name="title"
            placeholder="Blog Title"
            className="w-full p-3 border border-pink-200 mt-2  rounded-lg focus:outline-pink-400"
            value={formData.title}
            onChange={handleChange}
            required
          />
          <label htmlFor="Username" className='text-lg font-[500] '>Username</label>
          <input
            type="text"
            name="username"
            placeholder="Your Name"
            className="w-full p-3 border border-pink-200 rounded-lg focus:outline-pink-400"
            value={formData.username}
            onChange={handleChange}
            required
          />
          <label htmlFor="Blog Title" className='text-lg font-[500] '>Enter Date</label>
          <input
            type="date"
            name="date"
            className="w-full p-3 border border-pink-200 rounded-lg focus:outline-pink-400"
            value={formData.date}
            onChange={handleChange}
            required
          />
          <label htmlFor="Blog Title" className='text-lg font-[500] '>Write Blog</label>
          <textarea
            name="content"
            placeholder="Write your blog content..."
            className="w-full p-3 border border-pink-200 rounded-lg focus:outline-pink-400"
            rows={6}
            value={formData.content}
            onChange={handleChange}
            required
          ></textarea>
          <label htmlFor="Blog Title" className='text-lg font-[500] mt-2'>Upload Image</label>
          <input
            type="file"
            name="image"
            accept="image/*"
            className="w-full p-2 bg-white border border-pink-200 mt-2 cursor-pointer rounded-lg"
            onChange={handleFileChange}
            {...(editId ? {} : { required: true })}
          />
          <div className="flex justify-between">
            <button
              type="submit"
              className="bg-pink-500 cursor-pointer hover:bg-pink-600 text-white font-semibold py-2 px-6 rounded-lg transition duration-200"
            >
              {editId ? '✏️ Update Blog' : '✨ Publish Blog'}
            </button>
            {editId && (
              <button
                type="button"
                onClick={resetForm}
                className="text-gray-500 bg-red-500 p-2 text-white rounded-full cursor-pointer hover:text-gray-800"
              >
                Cancel Edit
              </button>
            )}
          </div>
        </form>
      </div>

      {/* Blog List */}
      <div className="bg-white mt-10 rounded-lg shadow p-6 font-[Poppins]">
        <h3 className="text-xl font-semibold text-pink-900 mb-4 font-[Poppins]">📚 Blog List</h3>
        {blogs.length === 0 ? (
          <p className="text-gray-500">No blogs yet.</p>
        ) : (
          blogs.map((blog) => (
            <div
              key={blog.id}
              className="flex justify-between items-center border-b border-pink-100 py-2"
            >
              <div>
                <div className="font-[400] text-black">{blog.title}</div>
                <div className="text-sm text-gray-500">
                  {new Date(blog.date).toLocaleDateString()}
                </div>
              </div>
              <div className="flex space-x-3">
                <button
                  onClick={() => handleEdit(blog)}
                  className="text-blue-600 hover:underline cursor-pointer"
                >
                  ✏️ Edit
                </button>
                <button
                  onClick={() => handleDelete(blog.id)}
                  className="text-red-500 hover:underline cursor-pointer"
                >
                  🗑️ Delete
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default BlogForm;
